const { getContracts } = require("./utils");

const _getPool = async (signer) => (await getContracts(signer)).payoutPool;

const _getReporterRewards = async (signer, address) => (await _getPool(signer)).reporterRewardsAccumulated(address);

const _getProposerRewards = async (signer, blsKey) => (await _getPool(signer)).getClaimableProposerAmount(blsKey);

const _repayDebtAndClaimMultipleProposers = async (signer, blsKeyList) => {
    return (await _getPool(signer)).repayDebtAndClaimMultipleProposers(blsKeyList);
}

const _claimReporterReward = async (signer) => {
    return (await _getPool(signer)).claimReporterReward();
}

class PayoutPool {

    constructor(signer) {
        this.signer = signer;
    }

    getPool() {
        return _getPool(this.signer)
    }
    getReporterRewards(address) {
        return _getReporterRewards(this.signer, address);
    }

    getProposerRewards(blsKey) {
        return _getProposerRewards(this.signer, blsKey);
    }

    repayDebtAndClaimMultipleProposers(blsKeyList) {
        return _repayDebtAndClaimMultipleProposers(this.signer, blsKeyList);
    }

    claimReporterReward() {
        return _claimReporterReward(this.signer);
    }
}

module.exports = PayoutPool;